<template>
  <footer class="app-footer">
    <section class="app-footer__content">

      <!-- Disclaimer -->
      <div class="app-footer__disclaimer">
        <p>
          Copyright © {{ year }} Canada Drives. All rights reserved.
          Canada Drives® and the Canada Drives Logo design are
          registered trademarks of Canada Drives Ltd. Other
          trademarks are the property of their respective owners.
        </p>
        <p>
          *Subject to conditions of Canada Drives and its third parties
          who provide financing of vehicles to customers. Upon receipt
          of application from customers, Canada Drives will carefully
          review each application and will contact each customer for
          further information. If Canada Drives and its third parties
          approve a customer (along with his/her choice of eligible vehicle)
          for the Bonus Cash Offer, Canada Drives will inform the customer
          of the approval and the customer’s vehicle must be delivered to
          the customer by December 15, 2019. The Bonus Cash Offer may be a
          maximum of $3000 for an approved customer. This amount may differ,
          depending on each customer’s application, choice of vehicle and/or
          eligibility. The Bonus Cash Offer, if approved, will be provided to
          the customer by Canada Drives through electronic funds transfer
          within seven (7) business days of financing the vehicle. The
          customer must keep title to the vehicle for a minimum of six (6)
          months from the date of obtaining financing for the vehicle, in
          order to keep his/her Bonus Cash Offer. For more information,
          please contact Canada Drives’ Auto Financing team at
          <a href="tel:306-803-5711">306-803-5711</a>.
        </p>
      </div>

      <!-- Links -->
      <div class="app-footer__links">
        <div
          class="app-footer__links-item"
          v-for="(link, index) in footerLinks"
          :key="index"
          @click="showPopup(
            link.text,
            link.url
          )"
        >
          {{ link.text }}
        </div>
      </div>

      <div class="app-footer__phone">
        <a :href="`tel:${ phoneNumber }`">{{ phoneNumber }}</a>
      </div>
    </section>

    <!-- Iframe Popup -->
    <AppPopupIframe
      :show="popup.show"
      :title="popup.title"
      :url="popup.url"
      @hide="popup.show = false"
    />
  </footer>
</template>

<script>
/**
 * <app-footer></app-footer>
 * @desc application footer, with legal page links / popup
 */
import AppPopupIframe from '@/components/common/popups/AppPopupIframe'

export default {
  // Name
  name: 'app-footer',

  // Components
  components: {
    AppPopupIframe
  },

  // Data
  data () {
    return {
      year: new Date().getFullYear(),
      popup: {
        show: false,
        title: undefined,
        url: undefined
      },
      footerLinks: [{
        text: 'Privacy Policy',
        url: `${process.env.VUE_APP_SITE_URL}/privacy-policy`
      }, {
        text: 'Legal Agreements',
        url: `${process.env.VUE_APP_SITE_URL}/legal-agreements`
      }, {
        text: 'Website Terms of Use',
        url: `${process.env.VUE_APP_SITE_URL}/website-terms-use`
      }, {
        text: 'Contact',
        url: `${process.env.VUE_APP_SITE_URL}/contact`
      }],

      phoneNumber: '1-888-865-6402'
    }
  },

  // Methods
  methods: {
    showPopup (title, url) {
      this.popup = {
        show: true,
        title: title,
        url: url
      }
    }
  }
}
</script>

<style scoped lang="scss">
$footer-text-color: #95989A;
$footer-link-color: #808080;
$footer-border-color: #DBDBDB;

.app-footer {
  border-top: 1px solid $footer-border-color;
  background-color: #fff;
  text-align: center;
  padding: 15px;
  font-size: 8px;
  line-height: 1.6;
  overflow: hidden;

  @include breakpoint('tablet-portrait-up') {
    font-size: 13px;
  }

  &__content {
    max-width: 100%;
    margin: auto;
    color: $footer-text-color;
    text-align: center;

    @include breakpoint('tablet-portrait-up') {
      width: 730px;
    }

    @include breakpoint('desktop-up') {
      text-align: left;
      width: 1100px;
    }
  }

  &__disclaimer {
    p {
      margin: 20px 0;
    }
  }

  &__disclaimer a {
    font-weight: normal;
    font-size: 13px;
    line-height: 1.6;

    @include breakpoint('mobile-only') {
      font-size: 8px;
    }
  }

  &__email,
  &__link,
  a {
    cursor: pointer;
    color: $footer-link-color;
    text-decoration: none;

    &:hover {
      color: $theme-text-black;
    }
  }

  &__links {
    // width: 400px;
    max-width: 100%;
    text-align: center;
    margin: auto;

    @include breakpoint('desktop-up') {
      text-align: left;
      font-size: 14px;
    }
  }

  &__links-item {
    position: relative;
    display: inline-block;
    flex-shrink: 1;
    margin-right: 15px;
    cursor: pointer;

    &:hover {
      color: $theme-text-black;
    }

    &:after {
      content: '|';
      display: block;
      position: absolute;
      top: 0;
      right: -10px;
      pointer-events: none;
    }

    &:last-child {
      margin-right: 0;

      &:after {
        display: none;
      }
    }
  }

  &__phone {
    margin-top: 10px;
    color: $footer-link-color;

    @include breakpoint('desktop-up') {
      display: none;
    }
  }
}
</style>
